export function Laboratory(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="1296.000000pt"
        height="1642.000000pt"
        viewBox="0 0 1296.000000 1642.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,1642.000000) scale(0.100000,-0.100000)"
          fill="#000000"
          stroke="none"
        >
          <path
            d="M2514 16396 c-133 -52 -240 -122 -335 -223 -151 -160 -226 -339 -236
-564 -6 -144 9 -244 58 -369 74 -194 253 -384 441 -469 164 -75 164 -75 583
-81 l380 -5 3 -2751 2 -2751 -821 -1504 c-451 -827 -1161 -2127 -1577 -2889
-416 -762 -777 -1432 -803 -1490 -91 -204 -152 -409 -186 -630 -24 -153 -23
-498 0 -652 72 -469 257 -871 562 -1226 329 -382 771 -642 1297 -759 l123 -28
4440 -3 c3182 -2 4463 0 4520 8 202 28 491 115 680 206 595 285 1071 847 1244
1472 67 243 71 277 71 655 0 304 -2 356 -20 444 -39 194 -97 371 -184 557 -18
39 -383 712 -811 1496 -745 1364 -1455 2665 -2076 3805 l-289 530 0 2757 0
2758 353 0 c319 0 360 2 437 20 291 70 535 293 629 575 109 326 25 675 -217
912 -87 85 -187 150 -292 190 l-85 32 -3915 0 -3915 0 -61 -23z m5306 -4601
l5 -2890 23 -97 c28 -122 83 -281 129 -372 32 -63 833 -1533 1467 -2692 130
-238 239 -439 242 -448 5 -14 -5 -16 -82 -16 -195 0 -512 -33 -739 -76 -185
-36 -311 -69 -823 -215 -669 -191 -815 -215 -1227 -206 -391 9 -684 67 -1030
204 -132 52 -183 77 -485 236 -422 223 -889 337 -1375 337 -163 0 -412 -19
-481 -36 l-27 -7 41 74 c22 41 101 184 174 319 1082 1980 1348 2469 1384 2545
54 112 96 242 126 382 l23 108 3 2873 2 2872 1323 -2 1322 -3 5 -2890z"
            fill="currentColor"
          />
        </g>
      </svg>
    </div>
  );
}
